import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const CoachAssistantDeprecationModal = ({ visible, onClose }) => {
  const carePlatformUrl = process.env.NALURI_APP_CARE_PLATFORM;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      centered
      width={500}
    >
      <div style={{ padding: '20px 0' }}>
        <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px' }}>ATTENTION</h3>
        <p style={{ fontSize: '16px', lineHeight: '1.6', margin: 0 }}>
          Coach Assistant login is no longer supported in the Coach Platform (CP1.0). Please proceed to{' '}
          {carePlatformUrl ? (
            <a 
              href={carePlatformUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#1890ff', textDecoration: 'underline' }}
            >
              Naluri Care
            </a>
          ) : (
            <span style={{ fontWeight: 'bold' }}>Naluri Care</span>
          )}{' '}
          to access this feature.
        </p>
      </div>
    </Modal>
  );
};

export default CoachAssistantDeprecationModal;




// WEBPACK FOOTER //
// ./src/features/common/CoachAssistantDeprecationModal.js